import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import MenuIcon from '../../Layout/Menu/MenuIcon';
import Icons from '../../../../components/Common/Icons/Icons';
import Link from '../../../../components/Common/UI/Link';

export default function UserMenu() {
  const navigate = useNavigate();
  const tempViewers = JSON.parse(localStorage.getItem('tempViewers') || '[]');
  const isAuthorized = tempViewers.length > 0;

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'LOGOUT') {
        sessionStorage.clear();
        window.location.href = '/guidance/single-sign-on';
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <div className="cursor-pointer">
          <MenuIcon icon={<Icons.User />} variant="header" size="large" />
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          side="bottom"
          align="end"
          sideOffset={10}
          className="
            min-w-[260px]
            rounded-lg
            bg-white
            p-1
            shadow-[0_8px_24px_rgba(0,0,0,0.12)]
            z-50
          "
        >
          {/* Title */}
          <div className="px-3 py-2 text-xs font-semibold text-gray-500">Profile Settings</div>

          {/* View Profile */}
          <DropdownMenu.Item
            className="
              flex items-center gap-3
              px-3 py-2
              text-sm text-gray-900
              rounded-md
              cursor-pointer
              outline-none
              hover:bg-gray-100
            "
            onSelect={() => navigate('/guidance/profile')}
          >
            <Icons.BellFilled className="w-4 h-4 opacity-70" />
            <span>View Profile</span>
          </DropdownMenu.Item>
          {!isAuthorized && (
            <DropdownMenu.Item
              className="
                flex items-center gap-3
                px-3 py-2
                text-sm text-gray-900
                rounded-md
                cursor-pointer
                outline-none
                hover:bg-gray-100
              "
              onSelect={() => navigate('/guidance/authorized-viewers')}
            >
              <Icons.Users className="w-4 h-4 opacity-70" />
              <span>Manage Authorized Viewers</span>
            </DropdownMenu.Item>
          )}
          <DropdownMenu.Separator className="my-1 h-px bg-gray-200" />
          <DropdownMenu.Item
            className="
              flex items-center gap-3
              px-3 py-2
              text-sm
              rounded-md
              cursor-pointer
              outline-none
              text-gray-600
              hover:bg-red-50 hover:text-red-700
            "
            onSelect={() => {
              window.parent.postMessage({ type: 'LOGOUT' }, '*');
            }}
          >
            <Icons.Reload className="w-4 h-4 opacity-70" />
            <span>Logout</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
